let Environment = {
  // API_URL: "https://stagingstablenft.quecko.com/",                    // stagging IP
  API_URL: "https://api.stablenft.com/",                                // Live IP
};

export default Environment;